import React, { Fragment } from 'react'
import Content from 'blocks.app/content/content'
import AdvertisingCampaignsAddMethods, {
    IAdvertisingCampaignsAddProps,
    IState,
} from './advertisingCampaigns_add.local.methods'
import AdvertisingCampaignsAddSidebar from './__sidebar/advertisingCampaigns_add__sidebar'
import AdvertisingCampaignsAddEmpty from './__empty/advertisingCampaigns_add__empty'
import AdvertisingCampaignsAddSummary from './__summary/advertisingCampaigns_add__summary'
import Catalog from 'blocks.app/catalog/catalog'
import EditText from 'blocks.simple/editText/editText'
import Button from 'blocks.simple/button/button'
import Stick from 'blocks.simple/stick/stick'
import LoaderItem from 'blocks.app/loader/__item/loader__item'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import translate from 'core/translate'
import { cn } from 'ethcss'
import { text as textStyles } from 'theme'
import { grid } from 'theme'
import styles from './advertisingCampaigns_add.jcss'
import { Typography } from 'atoms/Typography'
import { Steps } from 'atoms/Steps/Steps-view'
import { RouteLeavingGuard } from 'molecules/CustomPromt'
import { changeLocation } from 'features/routes'
import { connect, useSelector } from 'react-redux'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import { headActions } from 'features/head/Head.state'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import helpers from '../../../core/helpers'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { checkRoutePathName } from 'core/helpers/routes/routes'
import { getURLSearchParamsByLocation } from '../../../features/routes/utils'
import helpersFiles from '../../../core/helpers/_files'
import { SelectTime } from 'blocks.app/scheduleSettings/scheduleSettings'
import { Radio } from 'atoms/Radio'
import ShowMore from 'blocks.simple/showMore/showMore'
import Icon from 'blocks.simple/icon/icon'
import { AdvertisementIds } from '../../broadcasts/_advertisementIds/advertisementIds'
import { Switch } from '../../../atoms/Switch'
import { DevicesTags } from '../__devicesTags/DevicesTags'
import type { IRootState } from '../../../core/store/rootReducer'
import type { AppDispatch } from '../../../core/store'
import type { IFilesState } from '../../files/files.state'

type InsertionType = 'betweenBroadcast' | 'onPause' | 'replaceBroadcastContent' | 'areaInsert'
type DropdownTimeValue = string | number | { name?: string | number }

const getDropdownTimeValue = (value: DropdownTimeValue): string | number => {
    return typeof value === 'object' ? value.name ?? '' : value
}

const getTimeFormatState = (value: string): IState['hms'] => {
    return {
        h: value === 'h',
        m: value === 'm',
        s: value === 's',
    }
}

const AdvertisingCampaignsAdd = (p_: IAdvertisingCampaignsAddProps) => {
    const {
        state,
        setState,
        onChangeSetting,
        cancel,
        confirmCancel,
        closeCancelModal,
        onSubmit,
        getSaveText,
        onContinue,
        onSelectContentInSidebar,
        onSelectDisplays,
        onChangeDuration,
        onChangeVolume,
        onChangeCommonVolume,
        isVolumeSupport,
        getVolumeDiff,
        onChangeRepetitionCount,
        changeStep,
        onSelectContent,
        isPreventLeaveRoute,
        isShouldBlockNavigation,
        onSelectIds,
        onToggleSelectByTags,
        onSelectTag,
        onSelectAllTags,
    } = AdvertisingCampaignsAddMethods(p_)
    const locationQuery = getURLSearchParamsByLocation(p_.location)
    const query = helpers.getQuery(locationQuery, 'files')
    const filesState = useSelector<IRootState, IFilesState>((state) => state.files)

    const getAdBlockSettings = () => {
        const s_ = state

        if (!s_.isAdvBlock) {
            return null
        }

        return (
            <React.Fragment>
                <div className={grid.row}>
                    <div className={cn(styles.editRow)}>
                        <EditText
                            noSpaces
                            label={translate('name')}
                            value={s_.name}
                            data-field="name"
                            onChange={onChangeSetting}
                        />
                    </div>
                    <div className={cn(styles.editRow)}>
                        <Dropdown
                            label={translate('duration')}
                            type="hmsTime"
                            wrapperWidth={true}
                            isNotDropdown={false}
                            mod="withBorder"
                            options={[
                                { id: 5, name: 5 },
                                { id: 10, name: 10 },
                                { id: 30, name: 30 },
                            ]}
                            indentSize={'mini'}
                            onChange={(value: DropdownTimeValue) =>
                                setState((prevState: IState) => {
                                    return {
                                        ...prevState,
                                        duration: String(getDropdownTimeValue(value)),
                                        durationError: null,
                                    }
                                })
                            }
                            onChangeTimeFormat={(value: string) =>
                                setState((prevState: IState) => {
                                    return {
                                        ...prevState,
                                        hms: getTimeFormatState(value),
                                    }
                                })
                            }
                            hmsState={s_.hms}
                            value={s_.duration}
                            searchable={true}
                            notFilterOnSearch={true}
                            placeholderAsValue={true}
                            hideNotFound={true}
                        />
                    </div>
                </div>
                <div className={cn(grid.row, grid.mt_md)}>
                    <Checkbox
                        checked={s_.applyToNewDigitalSignage}
                        label={translate('applyToNewDisplays')}
                        onClick={(applyToNewDigitalSignage: boolean) => {
                            setState((prevState: IState) => {
                                return {
                                    ...prevState,
                                    applyToNewDigitalSignage,
                                }
                            })
                        }}
                    />
                </div>
            </React.Fragment>
        )
    }
    const getControls = (enabled = true) => (
        <Stick enabled={enabled}>
            <div className={styles.controls}>
                <Button className={cn(grid.mr_mini)} onClick={cancel}>
                    {translate('cancel')}
                </Button>
                <Button mod="fill" onClick={onSubmit}>
                    {getSaveText()}
                </Button>
            </div>
        </Stick>
    )

    const s_ = state
    const isFiles = s_.step === 'files'
    const timeOptions = helpers.getTimeOptions()

    if (s_.loading) {
        return (
            <Content className={cn(grid.rowCenter)} toolbar={<div />}>
                <LoaderItem small={true} />
            </Content>
        )
    }

    if (!s_.fillersAdBlockCreated) {
        return <AdvertisingCampaignsAddEmpty onContinue={onContinue} />
    }

    const getSteps = () => {
        if (s_.insertionType === 'areaInsert') {
            return s_.steps.filter((step) => step.id !== 'devicesTags')
        }
        if (s_.insertionType === 'onPause') {
            return s_.steps.filter((step) => step.id !== 'devicesTags' && step.id !== 'advertisementIds')
        }
        if (s_.insertionType === 'replaceBroadcastContent') {
            return s_.steps.filter((step) => step.id !== 'devicesTags' && step.id !== 'advertisementIds')
        }
        if (s_.insertionType === 'betweenBroadcast') {
            return s_.steps.filter(
                (step) => step.id !== 'advertisementIds' && (s_.selectByTags ? true : step.id !== 'devicesTags')
            )
        }
        if (checkRoutePathName('/advertisingCampaigns/add') || checkRoutePathName('/advertisingCampaigns/edit')) {
            return s_.steps.filter((step) => step.id !== 'devicesTags' && step.id !== 'advertisementIds')
        }

        return s_.steps
    }

    return (
        <Fragment>
            <Content
                toolbar={
                    <AdvertisingCampaignsAddSidebar
                        {...s_}
                        onChange={
                            isFiles
                                ? onSelectContentInSidebar
                                : s_.step === 'devicesTags'
                                ? onSelectAllTags
                                : onSelectDisplays
                        }
                        onEditItem={(selectedContentId: number) => {
                            setState((prevState: IState) => {
                                return {
                                    ...prevState,
                                    selectedContentId,
                                }
                            })
                        }}
                        selectedContent={
                            isFiles
                                ? state.content.find(
                                      (item: { sourceId: number }) => item.sourceId === state.selectedContentId
                                  )
                                : null
                        }
                        selectedTags={s_.selectedTags}
                        selectedFile={
                            isFiles
                                ? state.files.find((item: { id: number }) => item.id === state.selectedContentId)
                                : null
                        }
                        onChangeDuration={onChangeDuration}
                        onChangeVolume={onChangeVolume}
                        onChangeCommonVolume={onChangeCommonVolume}
                        getVolumeDiff={getVolumeDiff}
                        commonVolume={s_.commonVolume}
                        isVolumeDiff={s_.isVolumeDiff}
                        isVolumeSupport={isVolumeSupport}
                        onChangeRepetitionCount={onChangeRepetitionCount}
                        isAdvBlock={s_.isAdvBlock}
                    />
                }
            >
                <Steps active={s_.step}>
                    {getSteps().map((step, index) => (
                        <div key={`advertisingCampaignsAdd_${index}`} id={step.id} onClick={() => changeStep(step.id)}>
                            {translate(step.name)}
                        </div>
                    ))}
                </Steps>
                {(checkRoutePathName('/advertisingAds/add') || checkRoutePathName('/advertisingAds/edit')) &&
                    s_.insertionType === 'betweenBroadcast' &&
                    s_.step === 'displays' && (
                        <div>
                            <div className={styles.selectByTags}>
                                <span>{translate('selectDevicesByTags')}</span>
                                <Switch
                                    onChange={() => {
                                        onToggleSelectByTags(!s_.selectByTags)
                                    }}
                                    checked={s_.selectByTags}
                                />
                            </div>
                            <div className={styles.selectByTagsTip}>{translate('selectDevicesByTagsTip')}</div>
                        </div>
                    )}
                {getControls()}
                {s_.step !== 'summary' && (
                    <div className={cn(styles.wrapper)}>
                        <div className={styles.settings}>
                            {s_.isAdvBlock && (
                                <Typography className={styles.title} type="title">
                                    {translate('advBlock')}
                                </Typography>
                            )}
                            <div className={cn(styles.inner, { [styles.none]: s_.step !== 'files' })}>
                                <div className={styles.inputWrapper}>
                                    <div className={styles.input}>
                                        {getAdBlockSettings()}
                                        {!s_.isAdvBlock && (
                                            <div>
                                                <div className={grid.row}>
                                                    <div className={cn(styles.editRow)}>
                                                        <EditText
                                                            noSpaces
                                                            label={translate('name')}
                                                            value={s_.name}
                                                            data-field="name"
                                                            onChange={onChangeSetting}
                                                        />
                                                    </div>
                                                    <div className={cn(styles.editRow, styles.noMargin)}>
                                                        <EditText
                                                            type={'area'}
                                                            label={translate('description')}
                                                            error={translate(s_.descriptionError || '')}
                                                            value={s_.description}
                                                            data-field="description"
                                                            onChange={onChangeSetting}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={cn(grid.row, grid.mt_md)}>
                                                    <div className={cn(styles.editRow)}>
                                                        <EditText
                                                            type={'date'}
                                                            label={translate('startDate')}
                                                            dateValue={s_.localStartDate}
                                                            minDate={s_.localStartDate}
                                                            maxDate={s_.localEndDate}
                                                            onChange={(startDate: string) => {
                                                                setState((prevState: IState) => {
                                                                    return {
                                                                        ...prevState,
                                                                        localStartDate: startDate,
                                                                        conflicts: [],
                                                                    }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div className={cn(styles.editRow, styles.noMargin, styles.zIndex)}>
                                                        <EditText
                                                            type={'date'}
                                                            label={translate('endDate')}
                                                            dateValue={s_.localEndDate}
                                                            minDate={s_.localStartDate}
                                                            onChange={(endDate: string) =>
                                                                setState((prevState: IState) => {
                                                                    return {
                                                                        ...prevState,
                                                                        localEndDate: endDate,
                                                                        conflicts: [],
                                                                    }
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                {!checkRoutePathName('/advertisingCampaigns/add') &&
                                                    !checkRoutePathName('/advertisingCampaigns/edit') && (
                                                        <div className={cn(grid.row, grid.mt_md, grid.normalCenter)}>
                                                            <Dropdown
                                                                label={translate('insertionType')}
                                                                wrapperWidth={true}
                                                                isNotDropdown={false}
                                                                mod="withBorder"
                                                                options={[
                                                                    {
                                                                        id: 'betweenBroadcast',
                                                                        name: translate('betweenBroadcast'),
                                                                    },
                                                                    { id: 'onPause', name: translate('onPause') },
                                                                    {
                                                                        id: 'replaceBroadcastContent',
                                                                        name: translate('replaceBroadcastContent'),
                                                                    },
                                                                    { id: 'areaInsert', name: translate('byAreas') },
                                                                ]}
                                                                value={s_.insertionType}
                                                                onChange={(value: { id: InsertionType }) =>
                                                                    setState((prevState: IState) => {
                                                                        return {
                                                                            ...prevState,
                                                                            insertionType: value.id,
                                                                        }
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                    )}
                                                {checkRoutePathName('/advertisingCampaigns/add') ||
                                                checkRoutePathName('/advertisingCampaigns/edit') ? (
                                                    <div className={cn(grid.row, grid.mt_md)}>
                                                        <div className={cn(styles.editRow)}>
                                                            <SelectTime
                                                                time={{
                                                                    label: translate('startTime'),
                                                                    type: 'tel',
                                                                    id: 'startTimeAdvCamp',
                                                                    mask: '99:99:99',
                                                                    value: s_.localStartTime,
                                                                    noFocus: true,
                                                                }}
                                                                timeOptions={timeOptions}
                                                                onChange={(value: string) =>
                                                                    setState((prevState: IState) => {
                                                                        return {
                                                                            ...prevState,
                                                                            startTime: value,
                                                                            localStartTime: value,
                                                                        }
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                        <div className={cn(styles.editRow, styles.noMargin)}>
                                                            <SelectTime
                                                                time={{
                                                                    label: translate('endTime'),
                                                                    type: 'tel',
                                                                    id: 'endTimeAdvCamp',
                                                                    mask: '99:99:99',
                                                                    value: s_.localEndTime,
                                                                    noFocus: true,
                                                                }}
                                                                timeOptions={timeOptions}
                                                                onChange={(value: string) =>
                                                                    setState((prevState: IState) => {
                                                                        return {
                                                                            ...prevState,
                                                                            endTime: value,
                                                                            localEndTime: value,
                                                                        }
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className={cn(grid.row, grid.mt_md, grid.normalCenter)}>
                                                        <div className={cn(grid.pr_mini)}>
                                                            {translate(
                                                                s_.insertionType === 'onPause'
                                                                    ? 'playAdEvery'
                                                                    : 'playAd'
                                                            )}
                                                        </div>

                                                        {s_.insertionType === 'onPause' && (
                                                            <div style={{ width: 280 }}>
                                                                <Dropdown
                                                                    id="repetitionIntervalMS"
                                                                    type="hmsTime"
                                                                    wrapperWidth={true}
                                                                    isNotDropdown={false}
                                                                    mod="withBorder"
                                                                    options={[
                                                                        { id: 5, name: 5 },
                                                                        { id: 10, name: 10 },
                                                                        { id: 30, name: 30 },
                                                                    ]}
                                                                    indentSize={'mini'}
                                                                    onChange={(value: DropdownTimeValue) =>
                                                                        setState((prevState: IState) => {
                                                                            return {
                                                                                ...prevState,
                                                                                repetitionIntervalMS: getDropdownTimeValue(
                                                                                    value
                                                                                ),
                                                                                conflicts: [],
                                                                            }
                                                                        })
                                                                    }
                                                                    onChangeTimeFormat={(value: string) =>
                                                                        setState((prevState: IState) => {
                                                                            return {
                                                                                ...prevState,
                                                                                hms: getTimeFormatState(value),
                                                                            }
                                                                        })
                                                                    }
                                                                    hmsState={s_.hms}
                                                                    value={s_.repetitionIntervalMS}
                                                                    searchable={true}
                                                                    notFilterOnSearch={true}
                                                                    placeholderAsValue={true}
                                                                    hideNotFound={true}
                                                                    placeholder={translate('emptyFieldError')}
                                                                />
                                                            </div>
                                                        )}
                                                        <div className={cn(grid.pl_mini, grid.pr_mini)}>
                                                            {translate('playAdFrom')}
                                                        </div>
                                                        <div className={cn(styles.minTimeWidth)}>
                                                            <SelectTime
                                                                time={{
                                                                    type: 'tel',
                                                                    id: 'startTimeAdvCamp',
                                                                    mask: '99:99:99',
                                                                    value: s_.localStartTime,
                                                                    noFocus: true,
                                                                }}
                                                                timeOptions={timeOptions}
                                                                onChange={(value: string) =>
                                                                    setState((prevState: IState) => {
                                                                        return {
                                                                            ...prevState,
                                                                            startTime: value,
                                                                            localStartTime: value,
                                                                        }
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                        <div className={cn(grid.pl_mini, grid.pr_mini)}>
                                                            {translate('playAdTo')}
                                                        </div>
                                                        <div className={cn(styles.minTimeWidth)}>
                                                            <SelectTime
                                                                time={{
                                                                    type: 'tel',
                                                                    id: 'endTimeAdvCamp',
                                                                    mask: '99:99:99',
                                                                    value: s_.localEndTime,
                                                                    noFocus: true,
                                                                }}
                                                                timeOptions={timeOptions}
                                                                onChange={(value: string) =>
                                                                    setState((prevState: IState) => {
                                                                        return {
                                                                            ...prevState,
                                                                            endTime: value,
                                                                            localEndTime: value,
                                                                        }
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                <span>
                                                    {(checkRoutePathName('/advertisingAds/add') ||
                                                        checkRoutePathName('/advertisingAds/edit')) && (
                                                        <div className={cn(grid.row, grid.mt_md)}>
                                                            <div className={cn(styles.editRow)}>
                                                                {s_.insertionType === 'onPause' &&
                                                                    translate('adWarning')}
                                                                {s_.insertionType === 'betweenBroadcast' &&
                                                                    translate('adOnBroadcastWarning')}
                                                                {s_.insertionType === 'replaceBroadcastContent' &&
                                                                    translate('replaceBroadcastContentWarning')}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className={cn(grid.row, grid.mt_md, grid.mb_md)}>
                                                        <div className={cn(styles.editRow, grid.row)}>
                                                            <ShowMore
                                                                trigger={
                                                                    <div className={styles.more}>
                                                                        <Icon
                                                                            containerClass={cn(grid.mr_micro)}
                                                                            type={
                                                                                s_.isShowAdvanced
                                                                                    ? 'arrow_up'
                                                                                    : 'arrow_down'
                                                                            }
                                                                            size={16}
                                                                        />
                                                                        {s_.isShowAdvanced
                                                                            ? translate('hide')
                                                                            : translate('more')}
                                                                    </div>
                                                                }
                                                                isShow={s_.isShowAdvanced}
                                                                onToggle={(isShowAdvanced: boolean) => {
                                                                    setState((prevState: IState) => ({
                                                                        ...prevState,
                                                                        isShowAdvanced: isShowAdvanced,
                                                                    }))
                                                                }}
                                                            >
                                                                <div
                                                                    className={cn(
                                                                        grid.row,
                                                                        grid.fullWidth,
                                                                        grid.p_mini,
                                                                        grid.mb_md
                                                                    )}
                                                                >
                                                                    <Radio
                                                                        className={cn(grid.p_micro)}
                                                                        selected={
                                                                            p_.timeToUse === 'utc'
                                                                                ? p_.timeToUse === 'utc'
                                                                                : s_.timeToUse === 'utc'
                                                                        }
                                                                        onClick={function () {
                                                                            setState((prevState: IState) => {
                                                                                return {
                                                                                    ...prevState,
                                                                                    timeToUse: 'utc',
                                                                                }
                                                                            })
                                                                        }}
                                                                        label={translate('useUtcTime')}
                                                                    />
                                                                    <Radio
                                                                        className={cn(grid.p_micro)}
                                                                        selected={
                                                                            p_.timeToUse === 'local'
                                                                                ? p_.timeToUse === 'local'
                                                                                : s_.timeToUse === 'local'
                                                                        }
                                                                        onClick={function () {
                                                                            setState((prevState: IState) => {
                                                                                return {
                                                                                    ...prevState,
                                                                                    timeToUse: 'local',
                                                                                }
                                                                            })
                                                                        }}
                                                                        label={translate('useLocalTime')}
                                                                    />
                                                                </div>
                                                            </ShowMore>
                                                        </div>
                                                    </div>
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className={cn(grid.col, grid.space)}>
                                    <Catalog
                                        filterItems={
                                            checkRoutePathName('/advertisingAds/edit') ||
                                            checkRoutePathName('/advertisingAds/add')
                                                ? [
                                                      { name: translate('images'), fileType: 'image', type: 'fs' },
                                                      { name: translate('video'), fileType: 'video', type: 'fs' },
                                                      { name: translate('audio'), fileType: 'audio', type: 'fs' },
                                                  ]
                                                : null
                                        }
                                        contentAndFolders={
                                            checkRoutePathName('/advertisingAds/edit') ||
                                            checkRoutePathName('/advertisingAds/add')
                                        }
                                        type={'files'}
                                        searchbarMod={'withShadow'}
                                        showHeaderButton={true}
                                        selectedItems={s_.files}
                                        onSelect={onSelectContent}
                                        disableFolderSelection={true}
                                        toggleControls={helpersFiles.isShowEditor(filesState, query)}
                                        autoSelectContentType={true}
                                    />
                                </div>
                            </div>
                            <div className={cn(styles.inner, { [styles.none]: s_.step !== 'displays' })}>
                                <div className={cn(grid.col, grid.space)}>
                                    <Catalog
                                        type={'displays'}
                                        searchbarMod={'withShadow'}
                                        selectedItems={s_.displays}
                                        onSelect={onSelectDisplays}
                                        onlyFolders={s_.selectByTags}
                                    />
                                </div>
                            </div>
                            {s_.step === 'devicesTags' && (
                                <DevicesTags
                                    selectedTags={s_.selectedTags}
                                    onSelectTag={onSelectTag}
                                    onSelectAllTags={onSelectAllTags}
                                    groupIds={s_.displays ? s_.displays.map((display) => display.id) : []}
                                />
                            )}
                            {s_.step === 'advertisementIds' && (
                                <div className={cn(styles.inner)}>
                                    <div className={cn(grid.col, grid.space)}>
                                        <AdvertisementIds
                                            selectOnly={true}
                                            onSelect={onSelectIds}
                                            selectedIds={s_.areaAdvertisementIds}
                                            filter={{
                                                digitalSignageId: s_.displays
                                                    ? s_.displays
                                                          .filter((display) => display.type === 'digitalSignage')
                                                          .map((display) => display.id)
                                                    : [],
                                                groupId: s_.displays
                                                    ? s_.displays
                                                          .filter((display) => display.type === 'group')
                                                          .map((display) => display.id)
                                                    : [],
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {s_.step === 'summary' && (
                    <div className={styles.wrapper}>
                        <div className={styles.settings}>
                            <AdvertisingCampaignsAddSummary
                                summary={{
                                    content: s_.content,
                                    startDate: s_.localStartDate,
                                    endDate: s_.localEndDate,
                                    displays: s_.displays,
                                    name: s_.name,
                                    description: s_.description,
                                    applyToNewDigitalSignage: s_.applyToNewDigitalSignage,
                                }}
                                conflicts={s_.conflicts}
                                isAdvBlock={s_.isAdvBlock}
                            />
                        </div>
                    </div>
                )}
                <RouteLeavingGuard
                    when={isPreventLeaveRoute()}
                    shouldBlockNavigation={isShouldBlockNavigation}
                    navigate={(path) => changeLocation(path)}
                    open={s_.isCancelModalOpen}
                    onClose={closeCancelModal}
                    onLeave={confirmCancel}
                    title={translate('notSaved')}
                    description={translate('notSavedDescriptionAdv')}
                    rejectLabel={translate('exit')}
                    acceptLabel={translate('continue')}
                />
            </Content>
        </Fragment>
    )
}

const mapStateToProps = (state: IRootState) => {
    return {
        settings: state.user.data!.settings,
        redirect: typeof state.user.redirect === 'string' ? state.user.redirect : null,
        isDeleted: state.user.isDeleted,
    }
}

const mapDispatchToProps = (dispatch: AppDispatch) => {
    return {
        emitError: (err: string) => dispatch(emitError(err)),
        setTitle: (title: string[]) => dispatch(headActions.setTitle(title)),
    }
}

const exportAdvertisingCampaigns = checkAvailableModule('advertisingCampaigns/add')
    ? connect(mapStateToProps, mapDispatchToProps)(AdvertisingCampaignsAdd)
    : null

export default exportAdvertisingCampaigns
